import { z } from "zod";
import { resolvedContractSchema } from "./txs.js";
export const nearbyWriteSchema = z.object({
    txHash: z.string(),
    blockNumber: z.number().nullable(),
    blockTimestamp: z.number().nullable(),
    isFocalTx: z.boolean(),
});
export const slotSummarySchema = z.object({
    leafSlot: z.string(),
    resolvedContract: resolvedContractSchema.nullable(),
    totalWrites: z.number(),
    focalBlockNumber: z.number().nullable(),
    blockRange: z.object({
        min: z.number(),
        max: z.number(),
    }),
    histogram: z.array(z.number()),
    focalBin: z.number().nullable(),
    nearbyWrites: z.array(nearbyWriteSchema),
});
export const slotActivityResponseSchema = z.object({
    slots: z.array(slotSummarySchema),
});
//# sourceMappingURL=slot-activity.js.map